function BreadCrumbsCtrl() {}
;
export default BreadCrumbsCtrl;